<template>
  <div class="home">
<!--
        controls
        indicators
-->
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide v-if="windowWidth<=576" :img-src="require('@/assets/img/GERA_Home_Background_Mobile.jpg')">
          <div class="text-home text-left">We<br>assemble<br>dreams</div>
        </b-carousel-slide>
        <b-carousel-slide v-else :img-src="require('@/assets/img/GERA_Home_Background.jpg')">
          <div class="text-home text-left">We<br>assemble<br>dreams</div>
        </b-carousel-slide>
    </b-carousel>
    <b-container class="prl-outside">
      <b-row>
      	<b-col cols="1" class="scrollBtn mx-auto text-center">
      		<img class="cursorp" src="@/assets/img/Btn_Scroll_Down.png" @click="scrollDown()"/>
      	</b-col>
      </b-row>
      <b-row >
      	<b-col cols="12" class="text-center mt-5 mb-5">
	        <h1 class="mt-3">GERA</h1>
	        <h2 class="mt-3">Montagen für Tischlereiprodukte GmbH</h2>
      	</b-col>
      </b-row>
      <b-row>
      	<b-col cols="12" class="text-center mb-5">
          <div class="ml-4 home-pics">
            <img src="@/assets/img/GERA_home_1.jpg" class="w-100 mt-3 mb-4">
            <img src="@/assets/img/GERA_home_2.jpg" class="w-100">
          </div>
	        <p class="text-left mt-3">
            {{$t('text1')}}
	        </p>
	        <p class="text-left">
            {{$t('text2')}}
	        </p>
	        <p class="text-left">
            {{$t('text3')}}
	        </p>
    		  <b-button class="gera-btn mx-auto mt60" @click="$router.push('/company')" style="width:300px;">{{$t('moreabout')}}</b-button>
        </b-col>
      </b-row>
      <b-row class="mx-center">
        <video
            title="Gera Montagen"
            style="background-color: rgb(0, 0, 0);width: 70%; height: auto; margin: 40px auto"
            webkit-playsinline="true"
            playsinline="true"
            :src="$store.state.domain +'video/GERA_Video.mp4'"
            autoplay
            muted
            controls="controls"
            @playing="playing"
            @ended="ended"
            @paused="paused">
        </video>
      </b-row>
      <b-row class="mx-center">
        <b-col cols="12">
          <a v-if="windowWidth<=768" href="https://zutuun.com/" target="_blank"><img src="@/assets/img/zutuun_partner_mobile.jpg"  rel="noopener" class="w-100 mt-3 mb-4"></a>
          <a v-else href="https://zutuun.com/" target="_blank"><img src="@/assets/img/zutuun_partner.jpg"  rel="noopener" class="w-100 mt-3 mb-4"></a>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  /*
  metaInfo: {
    title: 'GERA Montagen für Tischlereiprodukte GmbH',
    meta: [
      // { description: 'Wir bei GERA haben alle etwas gemeinsam: Unsere Begeisterung für Ästhetik, ein stets offenes Ohr für die Wünsche unserer Kunden und die ständige Suche nach neuen Herausforderungen.' },
      // { keywords: 'Gera, montagetischlerei, tischlerei, megayachten, hotels, ' },
      // { property: 'og:site_name', content: 'GERA' },
      // { property: 'og:title', content: 'GERA Montagen für Tischlereiprodukte GmbH' },
      // { property: 'og:description', content: 'Wir bei GERA haben alle etwas gemeinsam: Unsere Begeisterung für Ästhetik, ein stets offenes Ohr für die Wünsche unserer Kunden und die ständige Suche nach neuen Herausforderungen.' },
      // { property: 'og:url', content: 'https://gera.at' },
      // { property: 'og:image', content: 'http://gera.at/img/GERA_Home.jpg' },
      // { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  */
  data () {
    return {
      slide: 0,
      sliding: false,
      windowWidth: 1920
    }
  },
  methods: {
  	scrollDown() {
  		let element = document.getElementsByClassName('img-fluid')
  		let scrollPx = element[0].offsetHeight
  		window.scrollBy(0, scrollPx)
  	},
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  },
  created () {
    this.windowWidth =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    window.addEventListener('resize', () => {
      this.windowWidth =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    })
  }
}
</script>
<style>
html {
  scroll-behavior: smooth;
}
.home .carousel-control-prev, .home .carousel-control-next {
  width: auto !important;
}
.scrollBtn {
	margin-top:-70px;
	z-index:150;
}
.home-pics {
  float:right;width:35%;height:auto;
}
@media only screen and (max-width: 576px) {
	.scrollBtn {
		margin-top:-40px;
	}
	.scrollBtn img {
		width: 40px;
	}
}
</style>
<i18n>
  {
    "de": {
      "moreabout": "Mehr zum Unternehmen",
      "text1": "Bei der Montagetischlerei GERA haben alle etwas gemeinsam: Unsere Begeisterung für Ästhetik, ein stets offenes Ohr für die Wünsche unserer Kunden und die ständige Suche nach neuen Herausforderungen, wie etwa ästhetische Zimmer in Hotels, luxuriösen Yachten oder eleganten Einrichtungen.",
      "text2": "Darum streben wir nach Designs, die in totaler Harmonie mit dem Umfeld zur Perfektion werden. Von Mettersdorf in der wunderschönen Südsteiermark aus sind unsere hochqualifizierten Montagetischler rund um den Globus unterwegs, um unsere Leidenschaft, die Handwerkskunst und die Liebe zum Detail in Ihre Räumlichkeiten zu übertragen – ganz gleich ob Luxusyachten, Hotels, Vorstandsetagen, Konferenz- und Konzerthallen oder erlesene Privatobjekte. Und zwar von Graz über Shanghai bis nach San Francisco.",
      "text3": "Dabei ist uns vor allem die Zufriedenheit unserer Kunden wichtig. Höchste Qualität und ein zeitgerechtes, perfektes Ergebnis sind unsere Versprechen. Wir sind Ihr idealer Montagefachbetrieb und sehen uns als fairer Partner unserer Kunden und Mitarbeiter."
    },
    "en": {
      "moreabout": "More about our company",
      "text1": "We at GERA all have one thing in common: our enthusiasm for aesthetics, an ear that is always open to our clients’ desires and the fact that we are constantly looking for new challenges.",
      "text2": "That is why we endeavour to achieve designs that are in total harmony with their environment and become perfect. Our highly-qualified carpenters travel around the world to add our passion and love for detail to your premises, including luxury yachts, hotels, boardrooms, conference halls, concert halls or exquisite private property.",
      "text3": "Customer satisfaction is especially important to us. Unsurpassed quality and a perfect result done on time are what we promise. We see ourselves as a fair partner for our customers and employees."
    }
  }
</i18n>
